<template>
  <DropdownComponent class="breadcrumb-dropdown" placement="bottom-start">
    <ButtonComponent :label="current.label" :icon="['fal', 'angle-down']" @click="fetch">
      <template #label>
        <div v-if="promise" class="fade row between">
          <span>{{ $t('loading', { resource: null }) }}...</span>
          <FontAwesomeIcon :icon="['fal', 'spinner-third']" spin />
        </div>
      </template>
    </ButtonComponent>
    <template #dropdown>
      <ButtonComponent
        v-for="item in itemsComp"
        :key="item.value"
        :label="item.label"
        :disabled="item.value === current.id"
        :tag="item.tag || 'router-link'"
        @click="() => item.action()"
        :to="{ name: to.name, params: { id: item.value, step: to.step } }"
      />
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'

export default {
  props: {
    current: Object,
    to: {
      type: Object,
      default: () => ({ name: 'residential-edit', step: 'basis' }),
    },
    items: {
      type: [Array, Function],
      default: () => [],
    },
  },
  data() {
    return {
      promise: null,
      data: [],
    }
  },
  computed: {
    itemsComp: {
      get() {
        if (!this.data.length) return [this.current]
        return this.data
      },
    },
  },
  methods: {
    fetch() {
      if (this.data.length) return
      if (Array.isArray(this.items)) return (this.data = this.items)
      this.promise = this.items()
        .then(res => (this.data = res))
        .then(() => (this.promise = null))
    },
  },
  components: {
    DropdownComponent,
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb-dropdown {
  .elder-button {
    color: initial;
  }
  .elder-dropdown__trigger {
    .elder-button {
      &:before {
        background-color: black;
        opacity: 0.05 !important;
      }
    }
  }
}
</style>
